import React from "react";
import HeaderGroupTypeOption from "./HeaderGroupTypeOption.jsx";

export default function ContractHoldersHeaderGroupTypeOptions({
  contractHoldersGroups,
  options,
  setOptions,
  children,
}) {
  const handleChangeGroup = (groupOptions) => {
    setOptions({
      otherOptions: [],
      groupOptions,
    });
  };

  return (
    <div className="col-xs-12">
      <form>
        <fieldset>
          <legend className="sr-only">Select a group to display in the table below</legend>
          <div
            className="row form-group"
            id="groupfilter1"
            role="radiogroup"
            aria-label="contract holder list filtering options"
            aria-controls="contractholderlist"
          >
            {contractHoldersGroups.map((contractHoldersGroup) => (
              <HeaderGroupTypeOption
                key={contractHoldersGroup.naicsCode}
                contractHolderGroup={contractHoldersGroup}
                handleChangeGroup={handleChangeGroup}
                options={options}
              />
            ))}

            <label className="radio-inline">
              <input
                type="radio"
                id="allgroups"
                role="radio"
                name="filterValue"
                onChange={() => handleChangeGroup({})}
                checked={!options.groupOptions.group && !options.groupOptions.facet}
              />
              All Contract Holders / All Groups
            </label>
            {children}
          </div>
        </fieldset>
      </form>
    </div>
  );
}
